<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <v-row>
      <v-col
        style="max-width: 15rem !important"
        v-for="(table, index) in tables"
        :key="index"
        cols="12"
        md="3"
      >
        <sub-menu-card 
          :title="table.title" 
          :isSelected="table.name == $route.name"
          :itemKey="table.key"
         @click="subMenuClicked(table.name)"
        />
      </v-col>
    </v-row>
    <template v-if="$route.name == 'adminJarFailedJobs'">
      <jar-failed-jobs />
    </template>
    <template v-if="$route.name == 'adminLegalentitiesWithoutObj'">
      <jar-failed-obj-id />
    </template>
    
  </v-container>
</template>

<script>
  import math from '@/mixins/math'
  import JarFailedJobs from './JarFailedJobs.vue'
  import SubMenuCard from '@/components/cards/SubMenuCard'
  import JarFailedObjId from './JarFailedObjId.vue'

  export default {
    name: 'JarContainer',
    components: {
      SubMenuCard,
      JarFailedJobs,
        JarFailedObjId
    },
    mixins: [math],
    data() {
      return {
        pageloading: false,
        tables: [
          {
            'key': 'jarFailedJobs',
            'title': 'Nepavykę JAR duomenų perdavmai',
            'name': 'adminJarFailedJobs',
          },
          {
            'key': 'objIDNotFound',
            'title': 'Juridiniai asmenys be OBJ_ID',
            'name': 'adminLegalentitiesWithoutObj',
          }
        ],
      }
    },
    methods: {
      subMenuClicked(route) {
      this.loading = true
       this.$nextTick(() => {
          this.loading = false
          this.$router.push({ name: route })
        })
     
    },
    },
  }
</script>


<style lang="scss" scoped>
  .potipis {
      background: #8eb693;

  .v-card__text {
      &.active {
      background: #2c7837;
      color: #fff;
      }
  }
  }
  .tikrina-chip {
  max-width: 110px;
  }
</style>

